/** @jsx jsx */

import { Icon } from '@zapier/zinnia-icons';

import { Colors, Margin } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  getItemCss: showBottom => [
    css`
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      border: 1px solid ${Colors.GrayWarm3};
      border-bottom: none;
      border-radius: 3px;
      padding: 15px 10px;
    `,
    showBottom &&
      css`
        border-bottom: 1px solid ${Colors.GrayWarm3};
      `,
  ],
  iconCss: css`
    margin-right: 10px;
  `,
};

type Props = {
  error: string;
  index: number;
  totalErrors: number;
};

const LifecycleErrorItem = ({ error, totalErrors, index }: Props) => (
  <li css={Styles.getItemCss(totalErrors === 1 || index === totalErrors - 1)}>
    <Margin margin="0px 10px 0px 0px">
      <Icon
        color="StatusErrorWeaker"
        css={Styles.iconCss}
        name="formXCircle"
        size={20}
      />
    </Margin>
    {error}
  </li>
);

export default LifecycleErrorItem;
